import { Chip, Typography } from '@mui/material';

interface IProps {
  identifiers: string[];
}

export const PartnerIdentifiers = ({ identifiers }: IProps) => (
  <>
    <Typography variant='h6' sx={{ mt: 5, mb: 2 }}>
      Partnerkennungen
    </Typography>
    {identifiers.map((x, i) => (
      <Chip key={i} label={x} sx={{ m: 0.5 }} />
    ))}
  </>
);
